import { useState } from "react";
import { Play, Save, RotateCcw, Volume2, VolumeX } from "lucide-react";
import { SoundSliders } from "@/components/game/SoundSettings";
import { Journal } from "@/components/game/Journal";

const TABS = [["menu", "Menu"], ["journal", "Journal"]];

const MenuTab = ({ onResume, onSaveQuit, onRestart, muted, onToggleMute, saving }) => (
  <div className="grid sm:grid-cols-[1fr_1.1fr] gap-6 sm:gap-10">
    <div className="flex flex-col gap-3">
      <button className="pixel-btn flex items-center gap-2 justify-center" onClick={onResume} data-testid="pause-resume-button"><Play size={14} /> Resume</button>
      <button className="pixel-btn ghost flex items-center gap-2 justify-center" onClick={onSaveQuit} disabled={saving} data-testid="pause-save-quit-button">
        <Save size={14} /> {saving ? "Saving..." : "Save & Quit"}
      </button>
      <button className="pixel-btn ghost flex items-center gap-2 justify-center" onClick={onRestart} data-testid="pause-restart-button"><RotateCcw size={14} /> Restart Chapter</button>
      <p className="pixel-text text-base text-[#64748B] mt-2 hidden sm:block">Press [Esc] to resume · [J] journal</p>
    </div>
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="pixel-text text-base text-[#7DD3FC] tracking-widest">// SOUND</p>
        <button className="pixel-text text-lg text-[#9CA3AF] hover:text-[#F3F4F6] transition-colors flex items-center gap-1.5" onClick={onToggleMute} data-testid="pause-mute-button">
          {muted ? <VolumeX size={14} /> : <Volume2 size={14} />} {muted ? "Sound off" : "Sound on"}
        </button>
      </div>
      <SoundSliders />
    </div>
  </div>
);

export const PauseMenu = ({ initialTab = "menu", inventory, notes, onRead, ...props }) => {
  const [tab, setTab] = useState(initialTab);
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/75 backdrop-blur-[3px] p-3" data-testid="pause-menu">
      <div className="panel w-full max-w-2xl p-5 sm:p-8 rise max-h-full overflow-y-auto">
        <p className="pixel-text text-base text-[#7DD3FC] tracking-widest">// GAME PAUSED</p>
        <div className="flex items-end justify-between gap-4 mt-1 mb-6 border-b-2 border-[#2E3440]">
          <h2 className="font-display text-3xl sm:text-4xl font-black flicker pb-2">Paused<span className="text-[#DC2626]">.</span></h2>
          <div className="flex">
            {TABS.map(([k, label]) => (
              <button key={k} onClick={() => setTab(k)} data-testid={`pause-tab-${k}`}
                className={`pixel-text text-xl px-4 py-1 -mb-[2px] border-b-2 transition-colors ${tab === k ? "border-[#DC2626] text-[#F3F4F6]" : "border-transparent text-[#64748B] hover:text-[#9CA3AF]"}`}>
                {label}{k === "journal" && <span className="text-[#F59E0B] ml-1.5">{notes.includes("ch3:start") ? notes.length - notes.indexOf("ch3:start") - 1 : inventory.length + notes.length}</span>}
              </button>
            ))}
          </div>
        </div>
        {tab === "menu" ? <MenuTab {...props} /> : <Journal inventory={inventory} notes={notes} onRead={onRead} />}
      </div>
    </div>
  );
};
